// src/plugins/vuetify.js
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#4A95DA',
        accent: colors.grey.darken3,
        secondary: colors.amber.darken3,
        info: colors.teal.lighten1,
        warning: '#f97316',
        error: colors.deepOrange.accent4,
        success: colors.green.accent3,
        navigationColor: '#2A2A2A',
        appBarColor: '#21427D',
        cardColor: '#2A2A2A',
        backGroundColor: '#1F1F1F',
        sideNavColor: '#8CB6E1'
      },
      light: {
        primary: '#21427D',
        accent: colors.grey.darken3,
        secondary: colors.amber.darken3,
        info: colors.teal.lighten1,
        warning: '#f97316',
        error: colors.deepOrange.accent4,
        success: colors.green.accent4,
        navigationColor: '#F3F4F6',
        appBarColor: '#21427D',
        cardColor: '#FFFFFF',
        backGroundColor: '#F7FAFB',
        sideNavColor: '#21427D'
      }
    },
    dark: false // Set to true if you want the dark theme by default
  },
  treeShake: true
})
